import CustomModalHeader from 'components/Custom/CustomModalHeader'
import { useState, useEffect } from 'react'
import { FormGroup, Input, Modal, ModalBody } from 'reactstrap'

function ChangeLabelModal({
  showModal,
  setShowModal,
  currentLabel,
  onLabelChange,
}) {
  const [newLabel, setNewLabel] = useState('')
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    if (showModal) {
      setNewLabel(currentLabel || '')
      setErrorMessage('')
    }
  }, [showModal, currentLabel])

  const handleSubmit = () => {
    if (!newLabel.trim()) {
      setErrorMessage('Label cannot be empty')
      return
    }

    onLabelChange(newLabel.trim())
    setShowModal(false)
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit()
    }
  }

  return (
    <Modal
      isOpen={showModal}
      toggle={() => setShowModal(false)}
      size='md'
      centered
      scrollable
    >
      <CustomModalHeader
        title={'Change Field Label'}
        toggle={() => {
          setShowModal(false)
        }}
      />
      <ModalBody className='scrollbar justify-content-center text-center'>
        <p>Enter the new label for this field:</p>

        {errorMessage && <p className='text-danger'>{errorMessage}</p>}

        <FormGroup className='ml-0 mt-2'>
          <Input
            id='newLabel'
            name='newLabel'
            placeholder='Field label'
            type='text'
            value={newLabel}
            onChange={(e) => setNewLabel(e.target.value)}
            onKeyPress={handleKeyPress}
            autoFocus
          />
        </FormGroup>

        <div
          className='d-flex w-100 justify-content-center mt-4'
          style={{ gap: '1rem' }}
        >
          <button className='btn btn-success' onClick={handleSubmit}>
            Update Label
          </button>
          <button
            className='btn btn-secondary'
            onClick={() => setShowModal(false)}
          >
            Cancel
          </button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ChangeLabelModal
